module.exports = __webpack_public_path__ + "img/cunw.d031a90b.png";